module.exports = __webpack_public_path__ + "static/media/karl.7519a996.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/karl.png
// module id = 105
// module chunks = 0